import * as React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { PromoFormBlock } from '@design-system/promo-form-block';

import { LOCALES } from '../constants';

import '../styles/promo.scss';

export default function HomepageModal({ data, currentLocaleCode }) {
  const [isOpen, setIsOpen] = useState(true);
  const [cookies, setCookie] = useCookies(['homepage-modal']);

  function closeModal() {
    setCookie('homepage-modal', true, { path: '/' });
    setIsOpen(false);
  }

  useEffect(() => {
    if (cookies['homepage-modal']) {
      closeModal();
    }
  });

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative homepage-modal" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/80" />
          </Transition.Child>

          <div className="fixed inset-0">
            <div className="flex min-h-full items-start justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="container w-full max-w-5xl transform overflow-visible text-left align-middle transition-all">
                  <div className="rounded-2xl bg-white shadow-xl relative container-main">
                    <div className="grid grid-cols-1 sm:grid-cols-2">
                      <div className="modal-description">
                        <h2>{data?.title}</h2>
                        <p className="uppercase">{data?.text}</p>
                        <img
                          className="hidden sm:block"
                          src="https://eu-images.contentstack.com/v3/assets/blt981357b24a92e763/blt8c19fcc1e486cf28/6579bca0d718b5040a83bd7a/7814-450x350-aw-gadget-image-update-lavender-category-r0-min.png.webp"
                          alt={data?.image_alt}
                        ></img>
                      </div>
                      <div className="promo-form">
                        <PromoFormBlock
                          url="https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms"
                          formId={
                            currentLocaleCode === LOCALES.es.code
                              ? process.env.GATSBY_HOMEPAGE_POPUP_FORM_ID_ES
                              : process.env.GATSBY_HOMEPAGE_POPUP_FORM_ID
                          }
                          submitErrorMessage={data?.promoformblock_submit_error_message}
                        />
                      </div>
                    </div>
                    <button onClick={closeModal} className="close-modal">
                      x
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
